// extracted by mini-css-extract-plugin
export default {"page":"style_page__Zv89r","expiredWrapper":"style_expiredWrapper__J-B3g","expiredLink":"style_expiredLink__iHTtr"};